/* js function used in set delivery zip code */

define(['ziphelper','preauthchargesmodal'], function(ziphelper,preauthchargesmodal) {
  var zipCodeModal = {		
		 validateSuccess : undefined,
		 setSuccess : undefined,	
		 digit5Zip : undefined,
		 init : function() {
		    var zipcode = COSTCO.util.getBDZipCookie().zipCode;
		    if(zipcode!= null && zipcode!="undefined" && zipcode!=""){	
		    	$('#signin_zip').remove();
		    	$("#set-zip-code-parent").find(".zipcode-toggle").each(function(){
		    		$(this).hasClass("hidden") ? $(this).removeClass("hidden") : $(this).addClass("hidden");
		    	});
		    	$("#set-delivery-zipcode").find(".zipcode-toggle").each(function(){
		    		if($(this).hasClass("hidden")){
		    			$("#set-delivery-zipcode").attr('aria-label', messages.CHANGE_ZIP_CODE);		    			
		    		}else{
		    			$("#set-delivery-zipcode").attr('aria-label', messages.SET_ZIP_CODE);
		    		}		    		
		    	});
		    	
		    	var originalZipCode = COSTCO.util.getBDZipCookie().originalZipCode;
		    	
		    	if (originalZipCode!="") {
		    		$("#bdzip").text(originalZipCode);
		    	} else {
		    		$("#bdzip").text(zipcode);
		    	}
		    	
		    }
		    
		    $.validator.addMethod("countryspecificpostalcode", function( value, element, params ) {
				var zip_pattern = new RegExp(document.getElementById("zipcode_patterns").getAttribute("value"));
				return this.optional(element) || zip_pattern.test($.trim(value));
				
			}, messages.ERR_ENTER_ZIPCODE);
		    
		    //Added for BD set zipcode
		    //ALM40905 Avoid calling these functions for CrossSiteRequestForgeryErrorView and ProhibitedCharacterErrorView 
		    if(! $('#isErrorPage').val() || $('#isErrorPage').length == 0){
		    	zipCodeModal.generatePopovers();
		    }
		    
		    //Added for BD SetDeliveryLocationView page
		    // If div with id exist on page, show its belonging template content (ZIP code input)
		    if (zipCodeModal.isDeliveryLocationPage()){		    
		    	zipCodeModal.generateDeliveryLocationPage();		    	
		    }
		    if($('#delivery-zipcode-form') && $('#delivery-zipcode-form').length==1) {
		    	$('#delivery-zipcode-form').append(COSTCO.util.tmpl('template_ProductDetails'));
		    }
		    if($('#orderByItm-zipcode-form') && $('#orderByItm-zipcode-form').length==1) {
			    $('#orderByItm-zipcode-form').append(COSTCO.util.tmpl('template_OrderByItemNo'));
			}
		    
	    },
	    
	    generatePopovers : function(){
	    	if (typeof checkoutPage == "undefined" || (typeof checkoutPage != "undefined" && (checkoutPage == 'cart' || checkoutPage == 'confirmation' || !checkoutPage))) {
	    		let c = $.cookie('hashedUserId');
	    		var t = document.getElementById("template_SetDeliveryZip");
	    		var div = document.createElement("div");
	    		div.innerHTML = t.innerHTML;

	    		if (c && c != '""') {
	    			$(div).find('.invite-sign-up').addClass('hidden');
	    		} else {
	    			$(div).find('.invite-sign-up').removeClass('hidden');
	    		}
	    		t.innerHTML = div.innerHTML;
	    	}

	    	zipCodeModal.addMaskToZipInput($(t).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode'));	
	    	
	    	var selector = "#set-zip-code-parent a[open-flyout]";
	    	var content = "#template_SetDeliveryZip";
	    	COSTCO.util.click_popover(selector, content);
	    },
	    
	    generateDeliveryLocationPage : function(){	
    		$('#delivery-location-zip').html(COSTCO.util.tmpl('template_deliveryLocation', {}));
	    },
	    
    	// Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
	    addMaskToZipInput : function(zipInput){
	    	if (zipInput) {
		    	// Add mask to zip input in case US (global var shippingCountries[0] used to determine country)
		    	if ((shippingCountries != null) && (shippingCountries.length > 0) && (shippingCountries[0] == "US")) {
		    		zipInput.unmask().mask('00000-0000');
		    	}
	    	}
	    },
	    
	    getZipByAddressModal : function(tmpZip) {        	  	
		      COSTCO.dialog.createExtDialogBox({
		        title: messages.JS_DIALOG_CHK_DELIVERY_ADDRESS,
		        body: $('#tmpl_get_zip_by_address').html(),
		        primary: messages.JS_DIALOG_CHK_ADDRESS,
		        primary_event: function primary_event() {
		        	var formElement = $("#zip_by_address-modal-modal");
		        	zipCodeModal.ajaxGetZipByAddress(formElement, "processValidateZipCodeSuccess");
		        },
		        secondary: messages.JS_DIALOG_CANCEL
		      });
		      // prepop. zip inut text		      
		      $('#postalId').val(tmpZip);
		      //$('#formId').val(formid);
		      //deliveryZipCode
		 },
	    isDeliveryLocationPage: function(){
	    	if($('#delivery-location-zip').length!==0){
	    		return true;
	    	}
	    	else {
	    		return false;
	    	}
	    },
	    redirectToSignIn : function(url){
	    	window.location = url;
	    	return false;
	    },
	    changeZip_buttonClickChange : function(data, params, form, verifiedAddress){
	    	if(!window.location.href.includes('SinglePageCheckoutView')){
	    		$.cookie('deliveryDateCookie', null, { expires: -1, path:'/' });
	    		$('[name="selDeliveryDate"]').val('');
	    	}
			COSTCO.ziphelper.setZipCookie(data.SetDeliveryZip);
			COSTCO.ziphelper.setLocationCookie(data.Set_C_LOC_Cookie);
			$('#header-delivery-zip').find('#bdzip').text(data.SetDeliveryZip);
			if(verifiedAddress!=undefined){
				COSTCO.CAddress.submitAddress(data, params, form, verifiedAddress);
			}
			var submitUrl = "/AjaxBusinessDeliveryBrowse";
			var redirectUrl = window.location.href;
			var submitParams = [submitUrl, form, redirectUrl];	
			zipCodeModal.ajaxCallFormSubmit(form, params ? submitParams.concat(params) : submitParams, zipCodeModal.saveDetailsBeforePlaceOrder);
		},
		/**
		 * saveDetailsBeforePlaceOrder - to save the shipmode derived based on the 
		 * address change in review page 
		 * National-Delivery
		 */
		saveDetailsBeforePlaceOrder :function(){
			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
				if($('#shipping #address-modal-inline').length === 0) {
					if(COSTCO.util.isNdEnabled()){
						COSTCO.OrderSummary.updateSelectedShipDetails(parseFloat($.cookie('wcCartOrder')), undefined);
					}else{
						window.location.reload();
					}
				}
				if($('#shipping #address-modal-inline').length > 0) {
					window.location.href = window.location.href + '&forceFirstStep=true';
				}
			} else {
				if(typeof checkoutPage != "undefined" && checkoutPage == 'review' && COSTCO.util.isNdEnabled()){
					COSTCO.OrderSummary.updateSelectedShipDetails(parseFloat($.cookie('wcCartOrder')), undefined);
				}else{
					 window.location.reload();
				}
			}
			
		},
        buttonClickChange : function (zipCode,form, optParams, data, verifiedAddress) {
          //$.cookie('WC_BD_ZIP', zipCode);
          var submitUrl = "/AjaxBusinessDeliveryBrowse";
          var redirectUrl = window.location.href;
          if ($('#WC_CachedHeaderDisplay_Link_2').attr('href') != '' && $('#WC_CachedHeaderDisplay_Link_2').attr('href') != null) {
            redirectUrl = $('#WC_CachedHeaderDisplay_Link_2').attr('href');
          }
          if (window.location.href.includes('CheckoutCartDisplayView')) {
            var tmpUrl = window.location.href.replace('CheckoutCartDisplayView','CheckoutCartView');
            redirectUrl = tmpUrl;
          }
          if (typeof data!='undefined' && data != null && typeof verifiedAddress!='undefined' && verifiedAddress != null) {
            COSTCO.CAddress.submitAddress(data, optParams, form, verifiedAddress);
          }
          var submitParams = [submitUrl, form, redirectUrl];
          if (!window.location.href.includes('SinglePageCheckoutView')) {
            $.cookie('deliveryDateCookie', null, { expires: -1, path:'/' });
          }
          zipCodeModal.ajaxCallFormSubmit(form, optParams ? submitParams.concat(optParams) : submitParams, zipCodeModal.setSuccess);
        }, 
		changeZipDel_buttonClickChange : function(zipCode,submitParams){			
			zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
		},
		
		buttonClickViewCart : function(){
			if (typeof checkoutPage !== "undefined" && (checkoutPage === 'shipping' || checkoutPage === 'review')) {
				COSTCO.CAddress.closeModal();
				window.location.href = $('#return-to-cart').attr('href');
			}else{
				window.location.href = $('#set-zip-code-parent').data().cartlink;
			}
		}, 
		dialogAlert : function(popupMsg,form){
			COSTCO.dialog.createExtDialogBox({
				title : messages.ZIPCODE_DELIVERY_ALERT_HEADER,
				body: COSTCO.util.tmpl('tmpl_delivery_zipcode_alert',{
				messageTxt: popupMsg}),
				primary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
				secondary: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_VIEW_CART_BUTTON,
				secondary_event: function(){
					zipCodeModal.buttonClickViewCart()
				}
			});			
		},		
        dialog : function (zipCode, optParams, popupMsg, form, data, verifiedAddress, userDeliveryMethod) {
          var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
          var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
          var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
          COSTCO.dialog.createExtDialogBox ({
            title : titleMsg,
            body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode', {
                                    messageTxt: popupMsg,
                                    msgQuestion: messageQues}),
            primary: primaryButton,
            secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
            primary_event: function() {
              var isCheckoutFlow = false;
              if (typeof checkoutPage !== 'undefined') {
                if (checkoutPage=='review' || checkoutPage=='shipping' ) {
                  isCheckoutFlow = true;
                }
              }
              if (COSTCO.util.isNdEnabled() && !isCheckoutFlow && (data == null || !data.ShowAddressTypePopup)) {
                if (data != null && data.isNDOnly) {
                  $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Nationwide");
                }
                zipCodeModal.buttonClickChange(zipCode, form, optParams, data);
              } else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && COSTCO.zipCodeModal.isUserDeliveryMethodExists(data, userDeliveryMethod) && !verifiedAddress) {
                $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(userDeliveryMethod);
                zipCodeModal.buttonClickChange(zipCode, form, optParams, data);
              } else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && !COSTCO.zipCodeModal.isUserDeliveryMethodExists(data, userDeliveryMethod) && !verifiedAddress) {
                COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams, verifiedAddress);
              } else if (COSTCO.util.isNdEnabled() && isCheckoutFlow && verifiedAddress) {
                COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams, verifiedAddress);
              } else if (!COSTCO.util.isNdEnabled() && (data==null || !data.ShowAddressTypePopup || isCheckoutFlow)) {
                zipCodeModal.buttonClickChange(zipCode,form, optParams, data, verifiedAddress);
              } else {
                if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
                  $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
                  COSTCO.zipCodeModal.submitZipCode(form);
                } else {
                  COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, optParams);
                }
              }
            }
          });
        },
        isUserDeliveryMethodExists: function(data, userDeliveryMethod) {
          if (userDeliveryMethod === 'Local') {
            return data.isBDTruckZoneEnabledForWareHouse;
          }
          if (userDeliveryMethod === 'Nationwide') {
            return data.isNationalDeliveryEnabledForWareHouse;
          }
          return true;
        },
        changeZipDialog : function(data, params, popupMsg, form, verifiedAddress){
          var primaryButton = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON;
          var titleMsg = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER;
          var messageQues = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1;
          COSTCO.dialog.createExtDialogBox({
            title : titleMsg,
            body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode',{
              messageTxt: popupMsg,
              msgQuestion: messageQues}),
            primary: primaryButton,
            secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
            primary_event: function() {
              if (typeof checkoutPage !== 'undefined') {
                if (checkoutPage=='review' || checkoutPage=='shipping' ) {
                  isCheckoutFlow = true;
                }
              }
              if (data!=null && data.ShowAddressTypePopup && data.redirectURL[0] == "SetDeliveryZip") {
                if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
                  $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
                  COSTCO.zipCodeModal.submitZipCode(form);
                } else {
                  COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params, verifiedAddress);
                }
              } else {
                if (COSTCO.util.isNdEnabled()) {
                  if (isCheckoutFlow && verifiedAddress && !data.ShowDeliveryMethodPopup && (data.ExternalCarrierChange || data.WarehouseChange)) {
                    if (data.IsInBDTruckZoneOnly) {
                      $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
                      COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
                    } else if (data.isNDOnly) {
                      $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Nationwide");
                      zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
                    } else {
                      zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
                    }
                  } else {
                    COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params, verifiedAddress);
                  }
                } else {
                  zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
                }
              }
            }
          });
        },
		changeZipDelDialog : function(zipCode,submitParams,popupMsg){
		    		    
			COSTCO.dialog.createExtDialogBox({
				title : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_HEADER,
				body: COSTCO.util.tmpl('tmpl_change_delivery_zipcode',{
				messageTxt: popupMsg,
				msgQuestion: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_QUESTION1}),
				primary: messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_ZIP_CODE_BUTTON,
				secondary: messages.ZIPCODE_SELECTOR_CANCEL_BUTTON,
				primary_event: function(){
					zipCodeModal.changeZipDel_buttonClickChange(zipCode,submitParams) 					
				}
			});			
		},
		submitZipCodeFromPopover: function(event) {
			if (COSTCO.Header.checkIsZipSetByAkamai()) {
				// If user is on the page where Akamai tries to set ZIP code, enter forced submit flow
				COSTCO.util.setInSession('isForcedSubmitZipcode', true);
			}
			COSTCO.zipCodeModal.submitZipCode(event);
		},
		submitZipCode : function(event, validateSuccess, setSuccess, optParams, digit5Zip){
			 //('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val();
			// in case event has no currentTarget attribute, it means html form attribute is passed. Usually event attribute is passed
			var formElement = event;
			
			if (event.currentTarget) {formElement = $(event.currentTarget)};
			            
			var formElementZip = $(formElement).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode');
			var errorHolder = $(formElement).find("[critical-notification-holder]");
			errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
			// This style of validation allows for no error to be displayed until the User moves forward with request
			var deliveryMethodFlow = false;
			var selectedDeliveryMethod = $(formElement).find('#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod').val();
			if(selectedDeliveryMethod && selectedDeliveryMethod != ""){
				deliveryMethodFlow = true;
			}
			// Setting the currentZipCode hidden variable value because of intermittent cache issue in JSP 
			var zipcode = COSTCO.util.getBDZipCookie().zipCode;
			$(formElement).find('#BusinessDeliveryBrowseForm_FormInput_currentZipCode').val(zipcode);
			
			var validator = $(formElement).validate();
			
			$(formElementZip).rules("remove");
			
			$(formElementZip).rules('add', {
				required:true,
				'countryspecificpostalcode':true,
				messages: {
					required:messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
					countryspecificpostalcode:messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
				}
			});
			
			validator.form();
			var valid = validator.valid();
			
			if(valid){	
				validateSuccess ? zipCodeModal.validateSuccess = validateSuccess : zipCodeModal.validateSuccess = zipCodeModal.processValidateZipCodeSuccess; 
				setSuccess ? zipCodeModal.setSuccess = setSuccess : zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
				var submitUrl 	= "/AjaxBusinessDeliveryBrowse";
				var validateUrl = "/AjaxDeliveryZipValidation";
				var redirectUrl = window.location.protocol+'//'+window.location.host;
				if(window.location.href.includes('CheckoutCartDisplayView')){
					var tmpUrl = window.location.href.replace('CheckoutCartDisplayView','CheckoutCartView');
					redirectUrl = tmpUrl;
				}
				var submitParams   = [submitUrl, formElement, redirectUrl];			
				var validateParams = [validateUrl, formElement];
				var zipCookie = COSTCO.util.getBDZipCookie();
				var trimmedZip = $(formElementZip).val().trim();
				$(formElementZip).val(trimmedZip);
				digit5Zip ? zipCodeModal.digit5Zip = digit5Zip : zipCodeModal.digit5Zip = trimmedZip;
				
				if(zipCookie.zipCode.length > 0 && !deliveryMethodFlow) {
			    	zipCodeModal.ajaxCallFormSubmit(formElement, optParams ? validateParams.concat(optParams) : validateParams, zipCodeModal.validateSuccess);
			    }else{
			    	if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val() != '' && $(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val() != null){
						submitParams[2]= $(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_url").val();
					}else if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_redirectUrl").val() == 'ProductDetails'){
						submitParams[2]= document.URL;
					}else if ($(formElement).find("#WC_BusinessDeliveryBrowseForm_FormInput_redirectUrl").val() == 'OrderByItemsDisplayViewBD') {
						submitParams[2] ='OrderByItemsDisplayViewBD?storeId='+wcs.storeId+'&catalogId='+wcs.catalogId+'&langId='+wcs.langId+'&fromPage=OrderByItemsDisplayView';
					}else if (document.URL.indexOf('CashCardBalanceInquiry')!= -1) {
						submitParams[2] ='costco-shop-card';
					}else {
						submitParams[2]= document.URL;
					}
			    	zipCodeModal.ajaxCallFormSubmit(formElement, optParams ? submitParams.concat(optParams) : submitParams, zipCodeModal.setSuccess);
			    }
			}
		},
		
		
		submitZipCodeForValidation: function(form,validateSuccess,setSuccess,optParams,oldAddy,newAddy){			 
			validateSuccess ? zipCodeModal.validateSuccess = validateSuccess : zipCodeModal.validateSuccess = zipCodeModal.processValidateZipCodeSuccess;
			setSuccess ? zipCodeModal.setSuccess = setSuccess : zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
			var submitUrl 	= "/AjaxBusinessDeliveryBrowse";
			var validateUrl = "/AjaxDeliveryZipValidation";
			var redirectUrl = window.location.protocol+'//'+window.location.host;
			var submitParams   = [submitUrl, form, redirectUrl];			
			var validateParams = [validateUrl, form];
			var zipCookie = COSTCO.util.getBDZipCookie();
		    if(zipCookie.zipCode.length > 0) {
		    	zipCodeModal.ajaxCallFormSubmit(form, optParams ? validateParams.concat(optParams) : validateParams, zipCodeModal.validateSuccess,oldAddy,newAddy);
		    }	
		},
    /**
     * Function to change content of IP Sniffer popover if Akamai set zip code in client-zip-short cookie
     * @param  $popover - popover element used by jQuery
     */
    transformToIPSnifferPopover: function($popover) {
      $popover.find('.invite-sign-up').addClass('hidden');
      $popover.find('.text-shoot').addClass('hidden');
      $popover.find('.get-zip-code-form').addClass('hidden');
      $popover.find('.ip-sniffer-close-link').removeClass('hidden');
      $popover.find('.text-shoot-ip-sniffer').removeClass('hidden');
      let zipcode = COSTCO.util.getBDZipCookie().zipCode;
      let baseAlert = messages.ZIPCODE_POPUP_SR_ALERT_MESSAGE;
      COSTCO.util.announceSRMessage(baseAlert.replace("{0}", zipcode));
    },
		 /**
	     * Function to handle the successful zip code change
	     * @param  {[json]}  data - json response of the ajax call AjaxBusinessDeliveryBrowse
	     * @param  {[array]} params - parameters for page redirection
	     * @param  {String}  form - submitted form
	     * @return 
	     */
	   	processSetZipCodeSuccess: function(data, params, form){
			var errorHolder = $(form).find("[critical-notification-holder]");
			errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
			// If zip code entered is an error or left blank, display either business selected message or generic error message.
			// Otherwise redirect to previous page.
			var redirecturl = data.redirecturl;
			if ((data.errorMessage != null || data.errorMessage != "") && data.errorMessage != undefined){
				//Opens the tool tip window for IP sniffer
				if(COSTCO.Header.checkIsZipSetByAkamai()){
					$('#set-zip-code-parent a[open-flyout]').find("div").css('display','block');
					//COSTCO.util.removeFromSession("isZipSetByAkamai");
				}
				var zipUserEntered = $(params[1]).find("input[name='zipCodeFormDeliveryZipCode']").val();
				var originForm = $(params[1]).attr('id');
				if (data.errorMessage.indexOf("InactiveMessage") >= 0){
					errorHolder.removeClass("hidden").find("div").html(data.errorMessage.replace("InactiveMessage: ", "")).slideDown("fast");					
				} else if (zipUserEntered != "") {
					if  ((data.errorMessageKey != undefined && (data.errorMessageKey != null || data.errorMessageKey != "")) && (data.errorMessageKey == "ERR_INCOMPLETE_SEGMENTED_ZIP_CODE")) {											
						errorHolder.removeClass("hidden").removeClass("critical-notification").addClass("warning").find("div").html(zipCodeModal.refactorSegmentedZipNeededMsg(zipUserEntered, messages.ERR_INCOMPLETE_SEGMENTED_ZIP_CODE)).slideDown("fast");						
					} 
					else {
						errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
						COSTCO.zipCodeModal.showZipByAddressInlineError();
					}
				} 
				else{ // From storeErrorMessages__.properties
					errorHolder.removeClass("hidden").find("div").html(zipCodeModal.decodeHTMLText(data.errorMessage)).slideDown("fast");					
				}
			}else{
				if ((typeof data.newLocation !='undefined' && data.newLocation == true) && redirecturl.length > 0) {
					if(window.location.href  != redirecturl){
						window.location.href = redirecturl;						
					}
					else{
						$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
					}
				} else if (params[2] != "") {
					// replace "Logon" with "LogonForm?URL=%2f" or "UserRegistrationAdd" with "RegisterView?URL=%2f&isPharmacy=false" if needed					
					var tmpUrl = zipCodeModal.replaceForwardURL(params[2],"Logon", "LogonForm", "LogonForm?URL=%2f"); 
					tmpUrl = zipCodeModal.replaceForwardURL(tmpUrl,"UserRegistrationAdd", "RegisterView", "RegisterView?URL=%2f&isPharmacy=false");
					// Set IP-sniffed ZIP to header, and open IP-sniffer popover
					if (COSTCO.Header.checkIsZipSetByAkamai() && !COSTCO.Header.checkIsForcedSubmitZipcode()) {
						// STRY0169326 - Added check for Safari to reposition popover 
						if (COSTCO.util.isSafari()) {
							$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
							$('#set-zip-code-parent a[open-flyout]').popover('show');
						}
						$('div#set-zip-code-parent #bdzip').text(data.SetDeliveryZip);
						$('div#set-zip-code-parent .zip-exists').removeClass('hidden');
						$('div#set-zip-code-parent .zip-not-exists').addClass('hidden');
						COSTCO.zipCodeModal.transformToIPSnifferPopover($('#set-zip-code-parent a[open-flyout]'));
						$('#set-zip-code-parent a[open-flyout]').find("div").css('display', 'block');
						if (!$('#set-zip-code-parent .popover').is(':visible')) {
							$('#set-zip-code-parent a[open-flyout]').popover('show');
						}
					// Show address type modal if the zipcode is in BD Truck zone
					} else if(data.ShowAddressTypePopup){
						if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
							$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
							COSTCO.zipCodeModal.submitZipCode(form);
						} else {
							COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params);
						}
					}else{
						COSTCO.util.removeFromSession('isForcedSubmitZipcode');
						COSTCO.util.removeFromSession('isZipSetByAkamai');
						if (typeof (COSTCO.Lists) !== "undefined") {
							window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
						}
						if (COSTCO.util.isBusinessDelivery() && typeof (COSTCO.Checkout) != 'undefined' && COSTCO.Checkout.isCartPage()) {
							tmpUrl = '/CheckoutCartView';
						}
						if(!window.location.hash){
							window.location.href = tmpUrl;
						   }else {
							window.location.reload();
						   }
							
					}
				}
				if (data.currentZipCode != '' && data.currentZipCode != data.zipCodeFormDeliveryZipCode) {
					$.cookie('deliveryDateCookie', null, { expires: -1, path: '/' });
				}
				var whsCookie = $.cookie('WC_BD_WHS');
				if (whsCookie != null && whsCookie != '') {
					$('#bd-in-location-from-cookie').html('Location: ' + whsCookie);
				}
			}
		},
		
		/*
		 * utility function to decode html messages comming from .properties files such as StoreErrorMessages
		 */
		decodeHTMLText : function(encodedVal) {
		  let textArea = document.createElement('textarea');
		  textArea.innerHTML = encodedVal;
		  return textArea.value;
		},
		
		/*
		 * utility function to replace one string value with another
		 * "Logon" with "LogonForm?URL=%2f" in URL string
		 */
		replaceForwardURL : function(urlvalue, replaceme, controlString, replacewith) {
			var returnValue = urlvalue;
			if (returnValue.indexOf(controlString) == -1){
				returnValue = urlvalue.replace(replaceme, replacewith);
			}
			return returnValue;
		},
		
		launchZipModal : function(data, submitParams) {
			let zipcodeDeliveryMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
			var  errorMessage = COSTCO.util.isNdEnabled() 
				? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT5
				: zipcodeDeliveryMsg;
			errorMessage = errorMessage.replace(/\{0\}/g, data.CurrentDeliveryZip);
			errorMessage = errorMessage.replace(/\{1\}/g, data.SetDeliveryZip);			
			var popupMsg=errorMessage;
			
			zipCodeModal.changeZipDelDialog(data.SetDeliveryZip,submitParams,popupMsg);
		},
		launchModal : function(data, params, form, verifiedAddress, userDeliveryMethod) {
		
		  var fromZipCodeToDisplay = data.bdZipCookieOriginal;
		  if (fromZipCodeToDisplay == null || fromZipCodeToDisplay == "undefined" || fromZipCodeToDisplay == ""){	
			  fromZipCodeToDisplay = data.CurrentDeliveryZip;
		  }
			  
          var popupMsg = "";
          var isCheckoutFlow = false;
          var isDeliveryMethodChange = false;
          if (typeof checkoutPage !== 'undefined') {
            if (checkoutPage=='review' || checkoutPage=='shipping' ) {
              isCheckoutFlow = true;
            }
          }
          if (!COSTCO.util.isNdEnabled()) {
            // ND disabled flow
            popupMsg = COSTCO.util.isUSBDStore() ? messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF_USBD : messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT_ND_OFF;
            popupMsg = popupMsg.replace(/\{0\}/g, fromZipCodeToDisplay);
            popupMsg = popupMsg.replace(/\{1\}/g, data.SetDeliveryZip);
          } else if (data.RegisteredUser) {
            // ND enabled flow
            if (data.InactiveZipMessage.length > 0) {
              popupMsg = data.InactiveZipMessage;
            } else if (data.NewWarehouseAlert.length > 0) {
              popupMsg = data.NewWarehouseAlert;
            } else if ((!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange))) {
              var errorMessage2 ;
              if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
                errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
                isDeliveryMethodChange = true;
              } else {
                errorMessage2 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
              }
              errorMessage2 = errorMessage2.replace(/\{0\}/g, fromZipCodeToDisplay);
              errorMessage2 = errorMessage2.replace(/\{1\}/g, data.SetDeliveryZip);
              popupMsg=errorMessage2;			
            } else {
              var errorMessage3;
              if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
                errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
                isDeliveryMethodChange = true;
              } else {
                errorMessage3 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
              }
              errorMessage3 = errorMessage3.replace(/\{0\}/g, fromZipCodeToDisplay);
              errorMessage3 = errorMessage3.replace(/\{1\}/g, data.SetDeliveryZip);
              popupMsg=errorMessage3;
            }
          } else {
            var errorMessage1;
            if (data.SetDeliveryZip == data.CurrentDeliveryZip) {
              errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT9;
              isDeliveryMethodChange = true;
            } else {
              errorMessage1 = messages.ZIPCODE_SELECTOR_CHANGE_DELIVERY_TEXT8;
            }
            errorMessage1 = errorMessage1.replace(/\{0\}/g, fromZipCodeToDisplay);
            errorMessage1 = errorMessage1.replace(/\{1\}/g, data.SetDeliveryZip);
            popupMsg=errorMessage1;
          }
          if (data.StatusMessage == data.ZipStatusMessageList[5]) {
            zipCodeModal.dialogAlert(popupMsg,form);
          } else if (verifiedAddress 
                  && (data.StatusMessage == data.ZipStatusMessageList[4] 
                  || data.StatusMessage == data.ZipStatusMessageList[7])) {
              zipCodeModal.changeZipDialog(data, params, popupMsg, form, verifiedAddress);
          } else {

              if (!isCheckoutFlow && isDeliveryMethodChange) {
                zipCodeModal.viewDeliveryMethodModal(form, data, params);
              } else {
              zipCodeModal.dialog(data.SetDeliveryZip,params,popupMsg,form,data,verifiedAddress, userDeliveryMethod);
              }

          }
		},
		/**
	     * Function to validate the zip code entered by the user
	     * @param  {json}    data - json response of the ajax call AjaxDeliveryZipValidation
	     * @param  {[array]} params - parameters for page redirection
	     * @param  {String}  form - submitted form
	     * @return 
	     */
		processValidateZipCodeSuccess: function(data, params, form){			
			let forcedSubmitFlow = COSTCO.Header.checkIsForcedSubmitZipcode();
			// Temporarily proclaim this flow as non-forced, re-proclaim it as forced only if it doesn't uninterrupt
			COSTCO.util.removeFromSession('isForcedSubmitZipcode');
			var errorHolder = $(form).find("[critical-notification-holder]");
			//To read the address type to show the warning modal
			errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
  			if ((data.InactiveZipMessage && data.InactiveZipMessage.length > 0)) {
  				errorHolder.removeClass("hidden").find("div").html(data.InactiveZipMessage).slideDown("fast");
  			}else if (data.ZipStatusMessageList != undefined) {				
  				switch (data.StatusMessage) {
  				    //Warehouse Not Active - contract inactive
  				    case (data.ZipStatusMessageList[5]): // contract inactive
                        if (data.NewWarehouseSplashPageURL.length > 0) {
                            window.location.href = data.NewWarehouseSplashPageURL;
                        }else {
                            errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
                            COSTCO.zipCodeModal.showZipByAddressInlineError();
                        }
                        break;
                    //Delivery Zip Empty
                    case (data.ZipStatusMessageList[1]):    
                        errorHolder.removeClass("hidden").find("div").html(data.StatusMessage).slideDown("fast");                       
                        break;
                    //Delivery Zip Not Found  
                    case (data.ZipStatusMessageList[3]):
                        errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
                        COSTCO.zipCodeModal.showZipByAddressInlineError();
                        break;
  				    //Delivery Zip Address Type Change
  				    case (data.ZipStatusMessageList[7]):
                        if (data.ExternalCarrierChange || data.WarehouseChange || data.ShowChangeDeliveryZipModal){   
                          if (forcedSubmitFlow) {
                        	COSTCO.util.setInSession('isForcedSubmitZipcode', true);
                          }                        	
                          data.ShowChangeDeliveryZipModal = false;
                          zipCodeModal.launchModal(data,params,form);
                        } else if(data.ShowAddressTypePopup) {
                          if (forcedSubmitFlow) {
                            COSTCO.util.setInSession('isForcedSubmitZipcode', true);
                          }
                          if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
                            $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("Local");
                            COSTCO.zipCodeModal.submitZipCode(form);
                          } else {
                          COSTCO.zipCodeModal.viewDeliveryMethodModal(form, data, params);
                          }
                        }
  				    break;
  					//Delivery Zip Found
  					case (data.ZipStatusMessageList[0]):
  						var referrerUrl = window.location.href;
  						if(data.URL != null && data.URL != '' && (data.URL.includes(window.location.host) && data.URL.includes(".html")) ){
  							referrerUrl = data.URL;
  						}
  						var submitUrl 	= "/AjaxBusinessDeliveryBrowse";
  						var submitParams   = [submitUrl, params[1], referrerUrl];						
  						if(zipCodeModal.isDelDatePresent() && data.ShowAddressTypePopup!=null){
  							zipCodeModal.launchZipModal(data, submitParams);
  						}else{
  							if (forcedSubmitFlow) {
  								COSTCO.util.setInSession('isForcedSubmitZipcode', true);
  							}
  							zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
  						}
  						break;
  						
  						//Delivery Zip Same
  					case (data.ZipStatusMessageList[2]):
  						var referrer = window.location.href;
  					    //URL validation
  						if(data.URL != null && data.URL != '' && (data.URL.includes(window.location.host) && data.URL.includes(".html")) ){
  							referrer = data.URL;
  						} else if(referrer == ''){
  							referrer = window.location.protocol+'//'+window.location.host; 
  						}
  						var costcoHostName = zipCodeModal.extractHostname(wcs.productBaseURL);
  						var redirecHostName = zipCodeModal.extractHostname(params[2]);
  						var referrerHostName = zipCodeModal.extractHostname(referrer);
  						//This code will keep User on website if they arrive at zip-in page via external link
  						if (redirecHostName.includes(costcoHostName)){
  							window.location.href = referrer;
  						}else if (referrerHostName.includes(costcoHostName)){
  							window.location.href = referrer;
  						}else{
  							window.location.href = 'https://'+costcoHostName;
  						}						
  						break;
  						
  					case(data.ZipStatusMessageList[4]):  /// different zipcode, same warehouse						
  						var referrerUrl = document.URL;
  						if(data.URL != null && data.URL != '' &&  (data.URL.includes(window.location.host) && data.URL.includes(".html")) ){
  							referrerUrl = data.URL;
  						}
  						var submitUrl 	= "/AjaxBusinessDeliveryBrowse";
  						var submitParams   = [submitUrl, params[1], referrerUrl];
  						
  						if(zipCodeModal.isDelDatePresent()&& data.ShowAddressTypePopup!=null){
  							zipCodeModal.launchZipModal(data, submitParams);
  						}else{
  							zipCodeModal.ajaxCallFormSubmit(submitParams[1], submitParams, zipCodeModal.setSuccess);
  						}
  						break;	
  					
  					case (data.ZipStatusMessageList[6]): // segmented zip needed (Yellow)
  						{						
  						errorHolder.removeClass("hidden").removeClass("critical-notification").addClass("warning").find("div").html(zipCodeModal.refactorSegmentedZipNeededMsg(data.SetDeliveryZip, messages.ERR_INCOMPLETE_SEGMENTED_ZIP_CODE)).slideDown("fast");
  						}
  						break;
  					default:
  						errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
  						COSTCO.zipCodeModal.showZipByAddressInlineError();
  				}
            }
		},
		refactorSegmentedZipNeededMsg : function(deliveryZip, msg){
			var newZip = (deliveryZip == null) ? "" : deliveryZip;			
			var onClickEvent = "onclick=\"javascript: COSTCO.zipCodeModal.getZipByAddressModal("+newZip+");\"" //(not used)
			// Replace first {0} with newly entered zip code	
			var wReplacedParam = msg.replace('{0}', newZip);
			// Replace second {0} with newly entered zip code
			wReplacedParam = wReplacedParam.replace('{0}', newZip);
			// Next replace {1} with js function to open correct modal (not used)
			wReplacedParam = wReplacedParam.replace('{1}', onClickEvent);
			return wReplacedParam;			
		}, 
		extractHostname : function(url) {
			var hostname="";
			try {
				if (url.indexOf("://") > -1) {
					hostname = url.split('/')[2];
				}
				else {
					hostname = url.split('/')[0];
				}
				hostname = hostname.split(':')[0];
			} catch (e) {
				// TODO: handle exception
			}
			return hostname;
		},
		getBDDelDateCookie: function() {
			var z = $.cookie('deliveryDateCookie');
			if (z==null || z=='""') { z='';}
			return {delDate : z};
		  },
		  isDelDatePresent: function(){
				var bdDeliveryDate = zipCodeModal.getBDDelDateCookie().delDate;
				return  (bdDeliveryDate != null && bdDeliveryDate !='' && bdDeliveryDate != undefined);
		  },
		  
		  ajaxGetZipByAddress : function(form){				  
			  //clean error holders
			  var errorHolder = $(form).find("[critical-notification-holder]");
			  errorHolder.addClass("hidden").removeClass("warning").addClass("critical-notification");
			  $('.inline_error').remove();
			  //
			  
			  var addressArray = zipCodeModal.buildShortAddress(form);
		      var _dataType = 'json';
		      var _data = {};
		      var _event = event;
		      _data['formdata'] = encodeURIComponent(JSON.stringify(addressArray));
			  $('.modal-content').addClass('btn-disabled');
		      
			  $.ajax({
		        url: '/AjaxGetZipByAddress',
		        type: 'POST',
		        dataType: _dataType,
		        data: _data,
		        timeout: 30000		        
		      }).done(function (data) { // TODO - am refactor!
		    	  var oldZip = $(form).find('#postalId').val(); // REFACTOR tmp solution to keep value placeholder when modal window is closed
		    	  var tmpZip = JSON.parse(data.jsonValidatedAddress).returnedZip;
		    	  var tmpAddress = JSON.parse(data.jsonValidatedAddress).returnedAddress;
		    	  var tmpErrorCode = JSON.parse(data.jsonValidatedAddress).errorCode;
		    	  console.log('Returned data ' + tmpAddress);
		    	  console.log('Returned ZIP ' + tmpZip);
		    	  //if ((tmpErrorCode!=null) && (tmpErrorCode == 'ERR_GROUP1_INVALID_ADDRESS')) { // invalid address error from AjaxGetZipByAddress (empty zip returned)
		    	  if ((tmpZip==null) || (tmpZip=='')){	
    		  		  errorHolder.removeClass("hidden").find("div").html(messages.ERR_GROUP1_INVALID_ADDRESS).slideDown("fast");		    		  
		    	  } else { // if non empty zip returned
			    	  $(form).find('#postalId').val(tmpZip);
			    	  $(form).find('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(tmpZip);
			    	  zipCodeModal.setSuccess = zipCodeModal.processSetZipCodeSuccess;
			    	  
	    			  zipCodeModal.submitZipCode(form);		    		  
		    	  }		    	  
		      }).fail(function () {
		        // Timeout or error sets verifiedAddress to inputted array
		    	console.log('Error Calling Verification Service');  
		        console.log('Verification Address : ' + JSON.stringify(addressArray));
		      }).always(function () {
			        $('.modal-content').removeClass('btn-disabled');
		      });
		    },
		
		/*
	    * Returns previously entered zip code depending on the form where zip entry originates from
	    */
		getTypedZipCode: function() {
			  let tmpZipValue="";
			  let loginZipInput = $('#LogonFormBD #deliveryZipCode');
			  // if login page
			  if (loginZipInput.length > 0) {
				  tmpZipValue = $(loginZipInput).val(); 
			  } else if ((zipCodeModal.digit5Zip != null) && (zipCodeModal.digit5Zip != "")){
				  tmpZipValue = zipCodeModal.digit5Zip;
			  }
			  return tmpZipValue;
		},
		
		
		
		/*
	    * Build Address Array from a query selector
	    * Short Address consists of minimal ammount of mandatory attributes for the address verification service call
	    */
		buildShortAddress: function(form) {
			var addressObject = {};
			var addressArray = [];
			var formID = form.attr("id") == undefined ? '#zip_by_address-modal-modal' : form.attr("id");
			var _addrForm = zipCodeModal.getForm('#'+formID);			
			
			// init (prepopulate) zip code value if empty
			if ((_addrForm.find('[name=postal]').val() == null) || ((_addrForm.find('[name=postal]').val() == ""))){
				if (zipCodeModal.digit5Zip != undefined && zipCodeModal.digit5Zip != null) {_addrForm.find('[name=postal]').val(zipCodeModal.digit5Zip);}
			}
			
			// Init default country value in case global var (shippingCountries) is ommited
			var countryValue = "";
			if (_addrForm.find('[name=storeId]').val()== "11301") {countryValue = "US";}
			if (_addrForm.find('[name=storeId]').val()== "11303") {countryValue = "CA";} 

			addressObject['line1'] = _addrForm.find('[name=address1]').val();
			addressObject['line2'] = _addrForm.find('[name=address2]').val();
			addressObject['zip'] = _addrForm.find('[name=postal]').val();
			addressObject['country'] = shippingCountries[0] ? shippingCountries[0] : countryValue;

			addressArray.push(addressObject);
			return addressArray;
		},
		
		getForm: function(formID) {
		      return $(formID);
		},
		  
        /**
        * Invokes the ajax call by submitting the form
        * @param  {String}    form - submitted form element
        * @param  {[array]}   params - parameters required for form submission
        * @param  {[function]} callbackSuccess - the function to be called upon success
        * @param  {[String]} oldAddy - this is used in delivery page for edit scenario, stores the old addressId
        * @param  {[String]} newAddy - this is used in delivery page for edit scenario, stores the new addressId
        * @return {Boolean}
        */
        ajaxCallFormSubmit: function(form, params, callbackSuccess, oldAddy, newAddy) {
          var postData = form.serializeArray();
          if(sessionStorage.getItem('isGeoApiCalled') !== null){
        	  let obj = {name: "deleteBDLocationCookie", value: false};
              postData.push(obj);
          }
          
          if($('input[name="removeOriginalZipCookie"]').val() && $.cookie('WC_BD_ZIP_ORIGINAL')) {
              let obj = {name: "removeOriginalZipCookie", value: false};
              postData.push(obj);
          }
          
          var formURL = form.attr("action")=="javascript:void(0)"?params[0]:form.attr("action");
          if( params != null && $.type(params[0]) == 'object' ) {
            $(params[0]).addClass('disabled');
          }
          $.ajax(
          {
            url: formURL,
            type: 'POST',
            data: postData,
            dataType: 'json',
            success: function(data, textStatus, xhr) {
              if (data.errorCode) {
                if (data.errorCode == 2510) {// session timeout
                  document.location.href = 'Logoff?URL=ReLogonFormView&storeId='+wcs.storeId;
                  return;
                }
              } else {
            	  
            	if (data.ResidentialStatusMessage === 'Delivery Zip Not Found') {
    				var errorHolder = $(form).find("[critical-notification-holder]");
            		errorHolder.removeClass("hidden").find("div").html(messages.ERR_INVALID_DELIVERY_ZIP_CODE_MSG).slideDown("fast");
            		COSTCO.zipCodeModal.showZipByAddressInlineError();
            	} else {
            		
                    // BD only: Update WC_BD_LOC cookie if ZIP is set/changed
                    if (COSTCO.util.isBusinessDelivery() && data.zipCodeBDCookieSet && !sessionStorage.getItem('isGeoApiCalled')) {
                      if ($('#isGeocodeService').val() != "true") {
                        COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'))
                          .then(() => {
                            callbackSuccess(data, params, form, newAddy, oldAddy);
                        });
                      } else {
                        COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'))
                          .then(() => {
                            callbackSuccess(data, params, form, newAddy, oldAddy);
                        });
                      }
                    } else {
						COSTCO.util.removeFromSession('isGeoApiCalled');
                      callbackSuccess(data, params, form, newAddy, oldAddy);
                    }
            	}
              } 
            },
            error: function(xhr, textStatus, errorThrown) {
            zipCodeModal.ajaxCallErrorLog(xhr,textStatus, errorThrown, true);
            },
            complete: function () {
              if ( params != null && $.type(params[0]) == 'object') {
                $(params[0]).removeClass('disabled');
              }
              if (COSTCO.OrderItems !== undefined) {
                COSTCO.OrderItems.init();
                COSTCO.preauthchargesmodal.init();
              }
            }
          });	
        },
		   
		   //Displey alternate inline error messages on getzipbyaddress modal
		   showZipByAddressInlineError : function(){
			   var parentNode = $(".has_inline_error");
	       		if (parentNode != null){
		        		var newDiv = document.createElement("div");
		        		newDiv.innerHTML = messages.ADDRESS_NOT_IN_DELIVERY_AREA;
		        		newDiv.className = 'error inline_error'
		        		parentNode.append(newDiv);
	       		}
				newDiv.textContent
		   },
		   
		   //logs error on console
		   ajaxCallErrorLog : function(xhr,textStatus, errorThrown, printErrorThrown)
			{
				console.log("Status :: "+xhr.status);
				switch (textStatus) {
					case 'timeout':
						console.log(" timeout with server - ");
						break;
					case 'parsererror':
						console.log(" Parse Error - ");
						break;
					case 'error':
						console.log(" Error - ");
						break;
					case 'abort':
						console.log(" Aborted - ");
						break;
					default: console.log(" Unknown error - ");
				}	
				if(printErrorThrown == true){
					console.log(errorThrown);
				}
		   },
		   /**
		     * Function called to submit the akamai zip code
		     * @param  {String}    finalZipCode - akamai zip code
		    */
		   setAkamaiBDZipCode :function(finalZipCode){
			   COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(finalZipCode, COSTCO.Header.checkIsZipSetByAkamai());
		   },
		   submitSetDeliveryZipcodeForm :function(zipCode, insertSetDeliveryZipcodeForm, isCalledFromChangeAddressType){
			   if(insertSetDeliveryZipcodeForm){
			    	$('#set-zip-code-parent a[open-flyout]').popover("show");
			    	if(COSTCO.Header.checkIsZipSetByAkamai()){
			    		$('#set-zip-code-parent a[open-flyout]').find("div").css('display','none');
			    	}
			   }	
			   $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(zipCode);
			   
			   if (isCalledFromChangeAddressType === true) {
				   $('#WC_BusinessDeliveryBrowseForm_FormInput_isInitiatedFromChangeAddressType').val(true);
			   }
			   
			   COSTCO.zipCodeModal.submitZipCode($('#formSetDeliveryZip'));
			   if(!COSTCO.Header.checkIsZipSetByAkamai()){
				   $('#set-zip-code-parent a[open-flyout]').popover("hide");
			   }
		   },
		   /**
		     * Function called to show the form to set the zipcode when zipcode set by IP Sniffer
		    */
		   showSetZipcode :function(){
			   $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val('');
			   $('.get-zip-code-form').removeClass('hidden'); 
			   // Trigger click event to prevent automatic popover closing on mouse out/leave and set focus to input field
			   // (jQuery fails here, use vanilla Javascript)
			   if (document.querySelectorAll('#set-zip-code-parent a[open-flyout]')[0]) {
				   document.querySelectorAll('#set-zip-code-parent a[open-flyout]')[0].click();
			   }
			   if (document.querySelectorAll('input[name=zipCodeFormDeliveryZipCode]')[0]) {
				   document.querySelectorAll('input[name=zipCodeFormDeliveryZipCode]')[0].focus();
			   }
			   window.digitalDataEvents = window.digitalDataEvents || [];
			   digitalDataEvents.push({ui:"Delivery Location tooltip | change your Delivery Postal Code"});
		   },
    /**
     * Function called to close the tool tip window for IP Sniffer.
     */
    closeSetZipForm: function() {
      //$('.zip_flyout_block').addClass('hidden');
      $('#set-zip-code-parent .popover').addClass('hidden');
      if (COSTCO.Header.checkIsZipSetByAkamai()) {
        // STRY0158461: Force-submit the sniffed ZIP code
        COSTCO.zipCodeModal.forceSubmitZipCode();
      }
      window.digitalDataEvents = window.digitalDataEvents || [];
      digitalDataEvents.push({ui:"Delivery Location tooltip | Close",defer:true});
    },
    /**
     * STRY0158461: Function to force-submit the ZIP sniffed by Akamai.
     */
    forceSubmitZipCode: function() {
        let zipCode = $('div#set-zip-code-parent #bdzip').text().trim();
        if (zipCode && !COSTCO.Header.checkIsForcedSubmitZipcode()) {
          console.log('Trying to force-submit ZIP code [zipCode=' + zipCode + ']');
          COSTCO.util.setInSession('isForcedSubmitZipcode', true);
          COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(zipCode);
        }
      },
      
      /**
       * Displays the new Adress Type modal so that the user sets the address type (if in BD Truck zone)
       * @param  {String}    form - submitted form element
       */
    viewAddressTypeModal: function(form,data,params){
		let preventClose = COSTCO.Header.checkIsForcedSubmitZipcode();
		COSTCO.dialog.createExtDialogBox({
			title : messages.DELIVERY_OPTIONS,
			body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
			primary : messages.SET_DELIVERY_METHOD,
			popover : true,
			preventClose : preventClose,
			dialogclasses: 'nd-delivery-method-dialog',
			onshow: function() {
				$('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
				$('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
				$('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")			
			},
			onshown: function() {
				if (preventClose) {
					$(document).bind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
				}
			},
			onclose: function() {
				$(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
				$('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
				$('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
			},
			primary_event: function(){
				if(document.querySelector('input[name="nd-radio-group-input"]:checked') == null){
					$('.addresstype-setup-notification').removeClass("hidden");
					$('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
				}else{
					var addresstype = "C";
					if(document.querySelector('input[name="nd-radio-group-input"]:checked')!=null){
						addresstype = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
						$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedAddressType").val(addresstype);
					}
					window.digitalDataEvents = window.digitalDataEvents || [];
					if (addresstype == 'C') {
						digitalDataEvents.push({
							browseDeliveryMethod:"Local Business Delivery"
						});
					} else if (addresstype == 'R') {
						digitalDataEvents.push({
							browseDeliveryMethod:"National Delivery Method"
						});
					} else if (addresstype == 'P') {
						digitalDataEvents.push({
							browseDeliveryMethod:"Store Delivery Method"
						});
					}

					if(data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE" && addresstype == 'R'){
						COSTCO.zipCodeModal.showModalForResidentialError(data.SetDeliveryZip,form);
					}else if(data.ExternalCarrierChange || data.WarehouseChange){
						zipCodeModal.buttonClickChange(data.SetDeliveryZip,form,params)
					}else{
						data.ShowAddressTypePopup = null;
						if (data.ZipStatusMessageList != undefined) {
							COSTCO.zipCodeModal.processValidateZipCodeSuccess(data,params,form);
						} else {
							COSTCO.zipCodeModal.submitZipCode(form);
						}
					}
				}
			}
		});	
		$('.close').addClass("hidden");
	},
    /**
    * Displays the new Delivery Method modal so that the user sets the delivery method
    * @param  {String}    form - submitted form element, data, params, verifiedAddress
    */
    viewDeliveryMethodModal: function (form, data, params, verifiedAddress) {
      var showQuestionnaireModal = false;
      var isCheckoutFlow = false;
      COSTCO.dialog.createExtDialogBox({
        title : messages.DELIVERY_OPTIONS,
        body: COSTCO.util.tmpl('tmpl_delivery_address_modal'),
        primary : messages.SET_DELIVERY_METHOD,
        popover : true,
        dialogclasses: 'nd-delivery-method-dialog',
        onshow: function() {
          $('#delivery_address_modal_form').append($('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset'));
          $('#nd-zipcode-method-modal-body #nd-zipcode-method-fieldset').remove();
          $('.nd-delivery-method-dialog #costcoModalBtn2').attr("data-bi-tc", "ui:Browse | Choose Delivery Method | Set Delivery Method")
		  $('.addresstype-setup-notification').addClass("hidden");
		  $('.addresstype-setup-notification').find("div").html('');
          
          if (data.isBDTruckZoneEnabledForWareHouse === true) {
        	  $("#nd-local-delivery-modal-section").removeClass("hidden");
          } else {
        	  $("#nd-local-delivery-modal-section").addClass("hidden");
          }
          
          if (data.isNationalDeliveryEnabledForWareHouse === true) {
        	  $("#nd-nationwide-delivery-modal-section").removeClass("hidden");
          } else {
        	  $("#nd-nationwide-delivery-modal-section").addClass("hidden");
          }   
          
          if (data.isStorePickupEnabledForWareHouse === true) {
        	  $("#store-pickup-modal-section").removeClass("hidden");
          } else {
        	  $("#store-pickup-modal-section").addClass("hidden");
          }
                 
          $('#nd-local-delivery-radio-button').focus();
        },
        onclose: function() {
          $(document).unbind('click', COSTCO.zipCodeModal.showErrorOnClickOutsideModal);
          $('#nd-zipcode-method-modal-body').append($('#delivery_address_modal_form #nd-zipcode-method-fieldset'));
          $('#delivery_address_modal_form #nd-zipcode-method-fieldset').remove();
        },
        primary_event: function () {
          if (typeof checkoutPage !== 'undefined') {
            if (checkoutPage=='review' || checkoutPage=='shipping' ) {
              isCheckoutFlow = true;
            }
          }
          if(document.querySelector('input[name="nd-radio-group-input"]:checked') == null) {
            $('.addresstype-setup-notification').removeClass("hidden");
            $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);

            var isFocusSet = false;
            if (data.isBDTruckZoneEnabledForWareHouse === true) {
          	  $('#nd-local-delivery-radio-button').focus();
          	  isFocusSet = true;
            } 
            
            if (data.isNationalDeliveryEnabledForWareHouse === true && isFocusSet == false) {
          	  $('#nd-nationwide-delivery-radio-button').focus();
          	  isFocusSet = true;
            } 
            
            if (data.isStorePickupEnabledForWareHouse === true && isFocusSet == false) {
          	  $('#store-pickup-radio-button').focus();
            }

          } else {
            var deliveryMehod;
            if ($('input[name="deliveryMethod"]').length>0) {
              deliveryMethod = $("input[name='deliveryMethod']:checked").val();
            }
            var selectedDeliveryMethod = 'Local';
            if (document.querySelector('input[name="nd-radio-group-input"]:checked')!=null) {
            	
            	var uiSelectedDeliveryMethod = document.querySelector('input[name="nd-radio-group-input"]:checked').value;
            	
            	switch(uiSelectedDeliveryMethod) {
            		case "C":
            			selectedDeliveryMethod = "Local";
            			break;
            		case "R":
            			selectedDeliveryMethod = "Nationwide";
            			break;
            		case "P":
            			selectedDeliveryMethod = "Store-Pick-Up";
            			break;            			
            	}
              $(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val(selectedDeliveryMethod);
            }
            window.digitalDataEvents = window.digitalDataEvents || [];
            if (selectedDeliveryMethod === 'Local') {
            	digitalDataEvents.push({
            		ui:"Delivery Method Modal | Set Delivery Method | Local Business Delivery"
            	});
            } else if (selectedDeliveryMethod === 'Nationwide') {
                digitalDataEvents.push({
                	ui:"Delivery Method Modal | Set Delivery Method | Nationwide Delivery"
                });
            } else if (selectedDeliveryMethod === 'Store-Pick-up') {
                digitalDataEvents.push({
                	ui:"Delivery Method Modal | Set Delivery Method | Pick-Up"
                });
            }
            data.userSelectionDeliveryMethod = selectedDeliveryMethod;
            showQuestionnaireModal = (COSTCO.util.isNdEnabled() && selectedDeliveryMethod === 'Local');
            if (showQuestionnaireModal && isCheckoutFlow) {
              COSTCO.CAddressForm.showNationalDeliveryQuestionnaireModal_v2(form, data, params, verifiedAddress);
            } else {
              if (data.ResidentialStatusMessage == "ERR_INVALID_RESIDENTIAL_WAREHOUSE") {
                COSTCO.zipCodeModal.showModalForResidentialError(data.SetDeliveryZip,form);
              } else if (!isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange)) {
                COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip,form,params, data);
              } else if (isCheckoutFlow && !verifiedAddress) {
                  COSTCO.zipCodeModal.buttonClickChange(data.SetDeliveryZip,form,params, data);
              } else if (isCheckoutFlow && (data.ExternalCarrierChange || data.WarehouseChange || data.ShowDeliveryMethodPopup)) {
                COSTCO.zipCodeModal.changeZip_buttonClickChange(data, params, form, verifiedAddress);
              } else {
                data.ShowAddressTypePopup = null;
                if (data.ZipStatusMessageList != undefined) {
                  data.StatusMessage = data.ZipStatusMessageList[0];
                  COSTCO.zipCodeModal.processValidateZipCodeSuccess(data,params,form);
                } else {
                  COSTCO.zipCodeModal.submitZipCode(form);
                }
              }
            }
          }
        }
      });
    },
	validateShowDeliveryMethodModal: function(verifiedAddress) {
		return verifiedAddress.showDeliveryModal;
	},
    /**
     * Displays inline error message in the new Adress Type modal if user try to close it by clicking outside the modal
     * @param  event - Mouse click or keyboard press event
     */
    showErrorOnClickOutsideModal: function(event) {
      if ($(event.target).parents('.modal-content').length == 0) {
        $('.addresstype-setup-notification').removeClass("hidden");
        $('.addresstype-setup-notification').find("div").html(messages.ERR_DELIVERY_METHOD_NOT_SELECTED);
      }
    },
			showModalForResidentialError: function(zipCode,form){
				COSTCO.dialog.close();
				$(form).find("#WC_BusinessDeliveryBrowseForm_FormInput_userSelectedDeliveryMethod").val("");
				if (COSTCO.Header.checkIsZipSetByAkamai() && COSTCO.Header.checkIsForcedSubmitZipcode()) {
					// This part of code is entered during forced-submit, when Akamai sniffed the ZIP where BDTRUCKZONE=1 and NDFFMWHS=null,
					// and the user chose Residential Address
					COSTCO.util.removeFromSession("isZipSetByAkamai");
					COSTCO.util.removeFromSession('isForcedSubmitZipcode');
					$('div#set-zip-code-parent #bdzip').text('');
					$('div#set-zip-code-parent .zip-exists').addClass('hidden');
					$('div#set-zip-code-parent .zip-not-exists').removeClass('hidden');
					$('#set-zip-code-parent .popover').removeClass('hidden');
					$('#set-zip-code-parent a[open-flyout]').popover('show');
				} else if(COSTCO.Header.checkIsZipSetByAkamai()){
					$('#set-zip-code-parent a[open-flyout]').find("div").css('display','block');
					COSTCO.util.removeFromSession("isZipSetByAkamai");
				} else{
					if($(form).attr('id') != "formProductDetails"){
						$('#set-zip-code-parent a[open-flyout]').popover("show");
					}
				}
				$('.get-zip-code-form').removeClass('hidden');
				$('.zip-setup-notification').removeClass("hidden");
				$('.zip-setup-notification').find("div").html(messages.ERR_RESIDENTIAL_NOT_SERVICED_MSG);
				$('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').val(zipCode);
			},
			handleRadioButtonClick: function(element) {
		      $('#costcoModalBtn2').removeClass('btn-disabled');
		    },
		    changeAddressType: function(){
		    	var zipcode = COSTCO.util.getBDZipCookie().zipCode;
		    	
		    	COSTCO.zipCodeModal.submitSetDeliveryZipcodeForm(zipcode,true,true);
		    	
		    }
}
if(typeof window.COSTCO == 'undefined'){
	window.COSTCO = new Object();
}

window.COSTCO.zipCodeModal = zipCodeModal
return zipCodeModal;

});


// WEBPACK FOOTER //
// ./js/deliveryzipcode/setdeliveryzipcode.js